<template>
  <div class="bgHeader">
    <div class="container">
      <b-card
        class="mt-4"
        header="Бизнес карт эзэмшигчийн бүртгэл"
        style="padding-bottom: 20px"
      >
        <b-alert
          variant="warning"
          dismissible
          fade
          :show="showDismissibleAlert"
          @dismissed="showDismissibleAlert = false"
        >
          {{ alertMessage }}
        </b-alert>
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
          <div class="form-row">
            <div class="form-group col-md-6">
              <b-form-group label="Байгууллагын нэр:" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="form.organizationName"
                  aria-describedby="input-organizationName-feedback"
                  :state="organizationState"
                ></b-form-input>
                <b-form-invalid-feedback id="input-organizationName-feedback">
                  Байгууллагын нэр оруулна уу
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="form-group col-md-6">
              <b-form-group
                id="input-group-2"
                label="Бүртгэлийн дугаар:"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="form.registerNumber"
                  type="text"
                  aria-describedby="input-registerNumber-feedback"
                  :state="registerNumberState"
                  :formatter="formatRegister"
                ></b-form-input>
                <b-form-invalid-feedback id="input-registerNumber-feedback">
                  Бүртгэлийн дугаар 10 оронтой байна
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <b-form-group
                id="input-group-3"
                label="Хот/аймаг:"
                label-for="input-3"
              >
                <select
                  name=""
                  class="form-control heightAuto user-select"
                  v-model="form.city"
                  @change="getDistrict"
                >
                  <option
                    v-for="data in allCity"
                    :value="data.id"
                    :key="data.id"
                  >
                    {{ data.name }}
                  </option>
                </select>
              </b-form-group>
            </div>
            <div class="form-group col-md-6">
              <b-form-group
                id="input-group-4"
                label="Сум/дүүрэг:"
                label-for="input-4"
              >
                <select
                  name=""
                  class="form-control heightAuto user-select"
                  v-model="form.district"
                  @change="getKhoroo"
                >
                  <option
                    v-for="data in allDistrict"
                    :value="data.id"
                    :key="data.id"
                  >
                    {{ data.name }}
                  </option>
                </select>
              </b-form-group>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <b-form-group
                id="input-group-5"
                label="Хороо/баг:"
                label-for="input-5"
              >
                <select
                  name=""
                  class="form-control heightAuto user-select"
                  v-model="form.bag"
                  aria-describedby="select-bag input-2-live-feedback"
                  :state="validateState"
                >
                  <option
                    v-for="data in allKhoroo"
                    :value="data.id"
                    :key="data.id"
                  >
                    {{ data.name }}
                  </option>
                </select>
                <b-form-text id="select-bag"></b-form-text>
                <b-form-invalid-feedback id="input-2-live-feedback"
                  >-======================================</b-form-invalid-feedback
                >
              </b-form-group>
            </div>
            <div class="form-group col-md-6">
              <b-form-group
                id="input-group-6"
                label="Байр хашаа тоот:"
                label-for="input-6"
              >
                <b-form-input
                  id="input-6"
                  v-model="form.home"
                  type="text"
                  aria-describedby="input-home input-home-feedback"
                  :state="homeState"
                  trim
                ></b-form-input>
                <b-form-text id="input-home"></b-form-text>
                <b-form-invalid-feedback id="input-home-feedback">
                  Байр хашаа тоот оруулна уу
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <b-form-group label="Татвар төлөгчийн №:" label-for="input-7">
                <b-form-input
                  id="input-7"
                  v-model="form.taxPayerId"
                  aria-describedby="input-taxPayerId input-taxPayerId-feedback"
                  :state="taxPayerIdState"
                  trim
                ></b-form-input>
                <b-form-text id="input-taxPayerId"></b-form-text>
                <b-form-invalid-feedback id="input-taxPayerId-feedback">
                  Татвар төлөгчийн № оруулна уу
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="form-group col-md-6">
              <b-form-group
                id="input-group-10"
                label="Гадаад эсэх:"
                label-for="input-10"
              >
                <b-form-checkbox
                  id="input-group-11"
                  v-model="form.foreign"
                  value="1"
                  unchecked-value="0"
                >
                  Гадаад
                </b-form-checkbox>
              </b-form-group>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <b-form-group
                id="input-group-8"
                label="Имэйл хаяг:"
                label-for="input-8"
              >
                <b-form-input
                  id="input-8"
                  v-model="form.email"
                  type="email"
                  aria-describedby="input-mail input-mail-feedback"
                  :state="emailState"
                  trim
                ></b-form-input>
                <b-form-text id="input-mail"></b-form-text>
                <b-form-invalid-feedback id="input-mail-feedback">
                  Имэйл хаяг оруулна уу
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="form-group col-md-6">
              <b-form-group label="Байгууллагын утас:" label-for="input-12">
                <b-form-input
                  id="input-12"
                  v-model="form.phone"
                  type="number"
                  aria-describedby="input-live-help input-live-feedback"
                  :state="phoneState"
                  trim
                  :formatter="formatPhone"
                ></b-form-input>
                <b-form-text id="input-live-help"></b-form-text>
                <b-form-invalid-feedback id="input-live-feedback">
                  Утасны дугаар 8 оронтой байна
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <b-button type="reset" variant="warning" @click="redirect"
            >Буцах</b-button
          >
          <b-button style="float: right" type="submit" variant="primary"
            >Хүсэлт илгээх</b-button
          >
          <div>
            <Recaptcha
              ref="recap"
              @checkRecaptcha="checkRecaptcha"
              @recaptchaError="recaptchaError"
            />
          </div>
          <transition name="fade">
            <Success
              :successMessage="successMessage"
              v-if="successModal"
              @hideSuccessMessage="hideSuccessMessage"
            ></Success>
          </transition>
        </b-form>
      </b-card>
    </div>
  </div>
</template>

<script>
import Success from "@/views/plugin/success";
// import Recaptcha from "./VueRecaptcha";
import Recaptcha from "../user/VueRecapchaBusiness.vue";
export default {
  computed: {
    phoneState() {
      return this.form.phone.length >= 8
        ? (this.phoneCheck = true)
        : (this.phoneCheck = false);
    },
    emailState() {
      let validRegex =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      return this.form.email.match(validRegex)
        ? (this.emailCheck = true)
        : (this.emailCheck = false);
    },
    organizationState() {
      return this.form.organizationName.length > 0
        ? (this.organizationNameCheck = true)
        : (this.organizationNameCheck = false);
    },
    registerNumberState() {
      return this.form.registerNumber.length >= 10
        ? (this.registerNumberCheck = true)
        : (this.registerNumberCheck = false);
    },
    taxPayerIdState() {
      return this.form.taxPayerId.length > 0
        ? (this.taxPayerIdCheck = true)
        : (this.taxPayerIdCheck = false);
    },
    homeState() {
      return this.form.home.length > 0
        ? (this.homeCheck = true)
        : (this.homeCheck = false);
    },
    validateState() {
      return this.form.bag.length > 0 ? true : false;
    },
  },
  name: "BusinessCard",
  data() {
    return {
      form: {
        organizationName: "",
        registerNumber: "",
        foreign: 0,
        city: "",
        district: "",
        bag: "",
        home: "",
        taxPayerId: "",
        email: "",
        phone: "",
      },
      phoneCheck: false,
      emailCheck: false,
      organizationNameCheck: false,
      registerNumberCheck: false,
      taxPayerIdCheck: false,
      homeCheck: false,
      allCity: [],
      allDistrict: [],
      allKhoroo: [],
      show: true,
      showDismissibleAlert: false,
      alertMessage: "",
      successModal: false,
      successMessage: "",
      captchaItem: {
        captchaImage: "",
        captchaToken: "",
        captchaInput: "",
      },
      validateRecaptcha: false,
      errorMessage: "",
      step: 0,
    };
  },
  methods: {
    formatPhone(e) {
      return String(e).substring(0, 8);
    },
    formatRegister(e) {
      return String(e).substring(0, 10);
    },
    onSubmit(event) {
      event.preventDefault();

      if (!this.organizationNameCheck)
        this.showAlert("Байгууллагын нэр оруулна уу");
      else if (!this.registerNumberCheck)
        this.showAlert("Бүртгэлийн дугаар оруулна уу");
      else if (!this.form.city) this.showAlert("Хот аймаг сонгож оруулна уу");
      else if (!this.form.district)
        this.showAlert("Сум дүүрэг сонгож оруулна уу");
      else if (!this.form.bag) this.showAlert("Хороо баг сонгож оруулна уу");
      else if (!this.homeCheck)
        this.showAlert("Байр хашаа тоот сонгож оруулна уу");
      else if (!this.taxPayerIdCheck)
        this.showAlert("Татвар төлөгчйин дугаар оруулна уу");
      else if (!this.emailCheck) this.showAlert("имэйл оруулна уу");
      else if (!this.phoneCheck) this.showAlert("Утасны дугаараа оруулна уу");
      else {
        this.$refs.recap.checkSubmit(this.form);
      }
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.form.organizationName = "";
      this.form.registerNumber = null;
      this.form.types = null;
      this.form.foreign = 0;
      this.form.city = "";
      this.form.district = "";
      this.form.bag = "";
      this.form.home = "";
      this.form.taxPayerId = "";
      this.form.email = "";
      this.form.phone = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },

    getCity() {
      let json = {
        tokenId: "TokenDCA29144B44940BC8764D106649",
        cardHolderInfId: 0,
        type: "City",
        typeValue: 0,
      };
      this.$axiosApi
        .post(`card/constant/data`, json)
        .then((result) => {
          if (result.data.data.length > 0) this.allCity = result.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getDistrict() {
      let json = {
        tokenId: "TokenDCA29144B44940BC8764D106649",
        cardHolderInfId: 0,
        type: "District",
        typeValue: this.form.city,
      };

      this.$axiosApi
        .post(`card/constant/data`, json)
        .then((response) => {
          var result = response.data;
          if (result.status === 0) this.allDistrict = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getKhoroo() {
      let json = {
        tokenId: "TokenDCA29144B44940BC8764D106649",
        cardHolderInfId: 0,
        type: "Khoroo",
        typeValue: this.form.district,
      };

      this.$axiosApi
        .post(`card/constant/data`, json)
        .then((response) => {
          var result = response.data;
          if (result.status === 0) this.allKhoroo = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showAlert(data) {
      this.showDismissibleAlert = true;
      this.alertMessage = data;
    },
    hideSuccessMessage() {
      (this.successMessage = ""), (this.successModal = false);
      this.$router.push({ name: "login" });
    },
    redirect() {
      this.$router.push("login");
    },

    checkRecaptcha(response) {
      this.showDismissibleAlert = false;
      if (response.data === "Success") {
        this.successMessage = "Амжилттай хадгаллаа ";
        this.successModal = true;
      } else {
        this.showAlert(response.data);
      }
    },
    //change step
    recaptchaError(message) {
      this.showAlert(message);
      this.errorMessage = message;
      this.error = true;
    },
  },

  validate(success) {
    this.validateRecaptcha = success;
  },

  created() {
    this.getCity();
    // this.captcha();
  },
  components: {
    Success,
    Recaptcha,
  },
};
</script>

<style></style>
